import { immerable } from 'immer';

export type ErrorType = 'critic' | 'warning' | 'none';

export const ErrorTypeOrder: { [k: string]: number } = {
	['critic']: 0,
	['warning']: 1,
};

export interface IAbsDiagnosticErrorEntity {
	key: string;
	type: ErrorType;
	message: string;
}

const entityDefaults: IAbsDiagnosticErrorEntity = {
	key: '',
	type: 'none',
	message: '',
};

export abstract class AbsDiagnosticErrorEntity
	implements IAbsDiagnosticErrorEntity
{
	private [immerable] = true;
	public key = entityDefaults.key;
	public type = entityDefaults.type;
	public message = entityDefaults.message;

	protected constructor(params: Partial<IAbsDiagnosticErrorEntity>) {
		this.key = params.key ?? entityDefaults.key;
		this.type = params.type ?? entityDefaults.type;
		this.message = params.message ?? entityDefaults.message;
	}
}
